export const translateMessage = (errorMessage: string) => {
  if (errorMessage.includes('"contact_info" must be a valid email')) {
    return 'You have submitted an invalid email address.'
  } else {
    return errorMessage
  }
}
